import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import App from './app/App';

let reloading = false;

function handleChunkError() {
    if (reloading) return;
    reloading = true;
    document.documentElement.style.visibility = 'hidden';

    const doReload = () => {
        const url = new URL(window.location.href);
        url.searchParams.set('reload', Date.now().toString());
        window.location.replace(url.toString()); // replace вместо href — не оставляет запись в истории
    };

    if ('caches' in window) {
        caches.keys()
            .then(names => Promise.all(names.map(name => caches.delete(name))))
            .then(doReload)
            .catch(doReload);
    } else {
        doReload();
    }
}

// Ловим unhandled promise rejection (динамические import())
window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    const message = reason ? (reason.message || reason.toString()) : '';
    if (message.includes('Loading chunk') || message.includes('ChunkLoadError')) {
        event.preventDefault();
        handleChunkError();
    }
});

// Ловим синхронные ошибки + ошибки загрузки <script>/<link>
window.addEventListener('error', (event) => {
    const target = event.target;
    const message = event.message || '';

    if (message.includes('Loading chunk') || message.includes('ChunkLoadError')) {
        handleChunkError();
        return;
    }

    if (target instanceof HTMLScriptElement || target instanceof HTMLLinkElement) {
        const src = target.src || target.href || '';
        if (
            src.includes('garvex.tech') ||
            src.includes(window.location.hostname) ||
            src.startsWith('/')
        ) {
            handleChunkError();
        }
    }
}, true);

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.unregister();